<template>
  <!-- 添加dom记得适应手机端 -->

  <div class="mapcontainer" id="dn">
    <div class="infoview">
      <input
        id="btnStop"
        @click="gz"
        type="button"
        class="btn btn-primary"
        value="盖子"
      />
    </div>
    <Map :url="configUrl" @onload="onMapload" />
  </div>
</template>

<script>
import Map from "../components/mars3d/Map.vue";
import { isPC } from "../../static/util/pqtutil";
let ispc = true;
export default {
  components: {
    Map,
  },
  data() {
    const basePathUrl = window.basePathUrl || "";
    const scale = 1;
    return {
      configUrl: basePathUrl + "static/mapconfig/config3.json", // 配置文件
      //askurl: "http://mcc.wedam.com.cn/zhenchongearth",
      askurl: "",
      drawer: false,
      drawerUrl: "",
      // 客户端环境
      ispc: ispc,
      // 地图对象
      map: {},
      // 桩在地图上缩放的比例
      pileScale: scale,
      // 地形开挖对象
      terrainClip: {},
      // 开挖矩形区域参数
      graphic: null,
      // 开挖深度 * 缩放比例
      clipHeight: 36 * scale,
      // 开挖记录对象数组
      areaItems: [],
      // 桩图层
      pileGraphicLayer: {},
      // 桩数据
      piles: [],
      // 未施工桩图层
      otherPileGraphicLayer: {},
      // 未施工桩数据
      otherPiles: [],
      // 曲线数据
      chartData: {},
      // 曲线option
      chartOption: [
        { title: "电流" },
        { title: "深度" },
        { title: "填料量" },
        { title: "瞬时水量" },
        { title: "瞬时水压" },
      ],
      // 曲线是否显示
      showLeftChart: false,
      showRightChart: false,
      showLeftChart1: false,
      showLeftChart2: false,
      showRightChart1: false,
      showRightChart2: false,
      showRightChart3: false,
    };
  },
  beforeCreate() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      document.getElementsByTagName("body")[0].style =
        "transform: rotate(90deg)";
    }
  },
  mounted() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      document.getElementsByClassName("mapcontainer")[0].style =
        "height:" +
        window.screen.width +
        "px;width:" +
        window.screen.height +
        "px;";
    }
  },
  methods: {
    gz() {
      this.graphic._layer.show = !this.graphic._layer.show;
    },
    // 地图构造完成回调
    onMapload(map) {
      console.log("地图构造完成");
      this.map = map;
      this.flyToPile();
      // this.initTerrainClip()
      // this.initPileGraphicLayer()
    },
    flyToOnePerson() {
      const { map } = this;
    },
    // 跳转到桩
    flyToPile() {
      const { map } = this;
      this.stopRotate();

      let tiles3dLayer = new mars3d.layer.TilesetLayer({
        type: "3dtiles",
        name: "航拍",
        //url: "http://mcc.wedam.com.cn/zhenchongearth/static/mapconfig/aa/tileset.json",
        // url: "/static/place/tileset.json",mapconfig\suidao
        url: this.askurl + "/static/lsj/tileset.json",
        scale: 1,
        // position: { lat:  23.26, lng: 110, alt: 21511287 },
        // maximumScreenSpaceError: 100,
        maximumMemoryUsage: 4096,
        dynamicScreenSpaceError: true,
        cullWithChildrenBounds: false,
        skipLevelOfDetail: true,
        preferLeaves: true,
        // rotation: { z: -75 },
        // highlight: {
        //   type: mars3d.EventType.click, //默认为鼠标移入高亮，也可以指定click单击高亮
        //   color: "#00FF00",
        // },
        // popup: "all",
        // show: true,
        // center: { lat: 40.015824, lng: 116.426866, alt: -1.8 },
        flyTo: true,
      });
      map.addLayer(tiles3dLayer);

      // map.setCameraView({
      //   lat: 39.929247,
      //   lng: 116.42547,
      //   alt: 6283,
      //   heading: 2,
      //   pitch: -25,
      // });

      //加载的事件 只执行一次
      tiles3dLayer.on(mars3d.EventType.initialTilesLoaded, function (event) {
        console.log("触发initialTilesLoaded事件", event);
      });

      //会执行多次，重新加载一次完成后都会回调
      tiles3dLayer.on(mars3d.EventType.allTilesLoaded, function (event) {
        console.log("触发allTilesLoaded事件", event);
      });

      let graphicLayer = new mars3d.layer.GraphicLayer();
      map.addLayer(graphicLayer);

      let graphic = new mars3d.graphic.BoxEntity({
        position: [116.40505, 40.01766, 2172.2],
        rotation: { x: -75 },
        style: {
          dimensions: new Cesium.Cartesian3(2000.0, 2000, 50.0),
          opacity: 1,
          outline: true,
          color: "#667276",
        },
      });
      this.graphic = graphic;
      graphicLayer.addGraphic(graphic); // 还可以另外一种写法: graphic.addTo(graphicLayer)
    },
    // 地球旋转
    startRotate() {
      const { map, mars3d } = this;
      // 距离地面过近时，先回到初始状态
      if (map.getCameraDistance() < 1000000) {
        map.flyHome({ duration: 3 });
      }
      this.stopRotate();

      this.previousTime = map.clock.currentTime.secondsOfDay;
      map.on(mars3d.EventType.clockTick, this.map_onClockTick);
    },
    stopRotate() {
      const { map, mars3d } = this;
      map.off(mars3d.EventType.clockTick, this.map_onClockTick);
    },
    map_onClockTick(clock) {
      const { map } = this;
      let spinRate = 150;
      let currentTime = map.clock.currentTime.secondsOfDay;
      let delta = (currentTime - this.previousTime) / 1000;
      this.previousTime = currentTime;
      map.scene.camera.rotateRight(-spinRate * delta);
    },
  },
};
</script>

<style >
.mapcontainer {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.infoview {
  position: absolute;
  top: 0.6rem;
  left: 0.6rem;
  padding: 0.6rem 0.9rem;
  border-radius: 0.2rem;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0.2rem 0.9rem rgb(128 128 128 / 50%);
  z-index: 19870101;
}
.btn {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  margin-bottom: 0;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 0.2rem;
  outline: none;
}
.btn-primary {
  color: #fff;
  background-color: rgba(32, 160, 255, 0.2);
  border: 1px solid #e4eaec;
}
.checkbox {
  padding-left: 0.3rem;
}
.checkbox-inline {
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  font-weight: normal;
  vertical-align: middle;
  cursor: pointer;
}
input[type="checkbox"] {
  width: 0.8rem;
  height: 0.8rem;
}
.checkbox label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-bottom: 0.3rem;
}
.right-charts {
  z-index: 800;
  position: absolute;
  right: 22rem;
  top: 10px;
  font-size: 0.9rem;
  border: none;
  color: #ffffff;
  background: none;
}
.left-charts {
  z-index: 800;
  position: absolute;
  left: 0px;
  top: 9rem;
  font-size: 0.8rem;
  border: none;
  color: #ffffff;
  background: none;
}
.phoneCharts {
  height: 13rem;
  overflow: auto;
}
.rightPhoneCharts {
  right: 3rem !important;
}
.pcCharts1 {
  position: absolute !important;
}
.pcCharts2 {
  position: absolute !important;
  top: 10.5rem;
}
.pcCharts3 {
  position: absolute !important;
}
.pcCharts4 {
  position: absolute !important;
  top: 10.5rem;
}
.pcCharts5 {
  position: absolute !important;
  top: 21rem;
}
</style>


// WEBPACK FOOTER //
// src/components/ytj.vue